<template>
  <article class="profile">
    <a :href="profileUrl" target="_blank" class="profile__link">
      <div class="profile__photo">
        <div v-if="profilePhotoUrl" class="lazyload" role="img" :aria-label="fullName" :data-bg="profilePhotoUrl"></div>
        <svg v-else aria-hidden="true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
          <g transform="translate(2 2)">
            <path d="M0,16V14c0-2.2,3.6-4,8-4s8,1.8,8,4v2ZM4,4A4,4,0,1,1,8,8,4,4,0,0,1,4,4Z" fill="#b01c2e"></path>
          </g>
        </svg>
      </div>
      <div class="profile__main">
        <h1 class="profile__name">{{ fullName }}</h1>
        <p v-if="roleOrganisation" class="profile__role">{{ roleOrganisation }}</p>
      </div>
    </a>
  </article>
</template>
<script>
  export default {
    name: 'Profile',

    props: {
      profile: Object
    },

    computed: {

      /*
       * Returns the individual's profile URL
       *
       * @returns {string|false}
       */
      profileUrl() {
        return this.profile.profile_url
      },

      /*
       * Returns the individual's profile photo URL
       *
       * @returns {string|false}
       */
      profilePhotoUrl() {
        return this.profile.profile_photo
      },
      
      /*
       * Returns the individual's full name
       *
       * @returns {string|false}
       */
      fullName() {
        return `${this.profile.title} ${this.profile.forename} ${this.profile.surname}`
      },

      /*
       * Returns the individual's role
       *
       * @returns {string|false}
       */
      role() {
        return this.profile.role
      },

      /*
       * Returns the individual's organisation
       *
       * @returns {string|false}
       */
      organisation() {
        return this.profile.organisation
      },

      /*
       * Returns the individuals role and organisation
       *
       * @returns {string|false}
       */
      roleOrganisation() {

        // Initialise empty array for storing role organisation
        const roleOrganisation = []

        // Verify that the profile includes a role
        if (this.role) {

          // Push the profile role to the roleOrganisation array
          roleOrganisation.push(this.role)
        }

        // Verify that the profile includes an organisation
        if (this.organisation) {

          // Push the profile organisation to the roleOrganisation array
          roleOrganisation.push(this.organisation)
        }

        // Return comma joined string
        return roleOrganisation.join(', ');
      },
    }
  }
</script>
